import { render, staticRenderFns } from "./boco_treatments.vue?vue&type=template&id=d69f2c9c&"
import script from "./boco_treatments.vue?vue&type=script&lang=js&"
export * from "./boco_treatments.vue?vue&type=script&lang=js&"
import style0 from "./boco_treatments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports